import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import OfficeHelper from '../../../Helpers/ModelHelpers/OfficeHelper';
import AuthService from '../../../Services/authService';

export default class ClientSearchParams extends SearchParamsBase {
  static iconName = 'fa-solid fa-search';
  static saveType = 'ClientSearchParams';

  initialize() {
    const loggedInUser = AuthService.getInstance().GetLoggedInUser();
    this.ClientId = '';
    this.Name = '';
    this.OfficeId =
      loggedInUser?.officeId === null || loggedInUser?.officeId === undefined
        ? []
        : OfficeHelper.GetDefaultOfficeIds(`${loggedInUser.officeId}`);
    this.UseCreatedOnDateRange = false;
    this.CreatedOnDateStartDate = dateTimeHelper.firstDayOfTheActualMonth();
    this.CreatedOnDateEndDate = dateTimeHelper.lastDayOfTheActualMonth();
    this.UseModifiedDateRange = false;
    this.ModifiedDateStartDate = dateTimeHelper.firstDayOfTheActualMonth();
    this.ModifiedDateEndDate = dateTimeHelper.lastDayOfTheActualMonth();
    this.UseCheckInByDateRange = false;
    this.CheckInByDateStartDate = dateTimeHelper.firstDayOfTheActualMonth();
    this.CheckInByDateEndDate = dateTimeHelper.lastDayOfTheActualMonth();
    this.SimilarName = '';
  }

  static fieldsInSearchBox = [
    // { fieldName: "ClientId", label: "Client Id", className: "col-3", type: InputTypesEnum.Number },
    { fieldName: 'Name', label: 'Client Name or Id', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'SassieId', label: 'Apollo ID', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'OfficeId', label: 'Office', className: 'col-4', type: InputTypesEnum.OfficeOrGroupSelect },

    { fieldName: 'SalesRepId', label: 'Primary Sales Rep', className: 'col-3', type: InputTypesEnum.UserSelect },
    { fieldName: 'AcctMgrId', label: 'Primary Account Mgr', className: 'col-3', type: InputTypesEnum.UserSelect },
    { fieldName: 'IsActive', label: 'Is Active?', className: 'col-3', type: InputTypesEnum.Bool },
    { fieldName: 'Status', label: 'Status', className: 'col-3', type: InputTypesEnum.ClientStatusLookupItemSelect },
    { fieldName: 'MspartnerCode', label: 'Ms Partner Name', className: 'col-4', type: InputTypesEnum.MsPartnerSelect },

    { fieldName: 'Country', label: 'Country', className: 'col-4', type: InputTypesEnum.CountrySelect },
    { fieldName: 'IndustryCode', label: 'Indrusty', className: 'col-4', type: InputTypesEnum.IndustryLookupItemSelect },

    {
      fieldName: 'UseCreatedOnDateRange',
      label: 'Created On Date Range',
      className: 'col-3',
      type: InputTypesEnum.OnOff,
    },
    {
      fieldName: 'CreatedOnDateStartDate',
      label: 'Start Date (Created On)',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseCreatedOnDateRange,
    },
    {
      fieldName: 'CreatedOnDateEndDate',
      label: 'End Date (Created On)',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseCreatedOnDateRange,
    },
    { fieldName: 'CreatedBy', label: 'Created By', className: 'col-3', type: InputTypesEnum.UserSelect },

    {
      fieldName: 'UseModifiedDateRange',
      label: 'Modified On Date Range',
      className: 'col-3',
      type: InputTypesEnum.OnOff,
    },
    {
      fieldName: 'ModifiedDateStartDate',
      label: 'Start Date (Modified On)',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseModifiedDateRange,
    },
    {
      fieldName: 'ModifiedDateEndDate',
      label: 'End Date (Modified On)',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseModifiedDateRange,
    },
    { fieldName: 'ModifiedBy', label: 'Modified By', className: 'col-3', type: InputTypesEnum.UserSelect },

    {
      fieldName: 'UseCheckInByDateRange',
      label: 'Check In By Date Range',
      className: 'col-3',
      type: InputTypesEnum.OnOff,
    },
    {
      fieldName: 'CheckInByDateStartDate',
      label: 'Check In Start Date',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseCheckInByDateRange,
    },
    {
      fieldName: 'CheckInByDateEndDate',
      label: 'CheckIn End Date',
      className: 'col-3',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseCheckInByDateRange,
    },
    { fieldName: 'ApolloClientName', label: 'Apollo Client Name', className: 'col-3', type: InputTypesEnum.Text },
  ];
}
